export default __webpack_public_path__ + "static/media/AKASH PATIL.93b29b04.jpg";